import { useState, useRef, useCallback } from "react";

import {
  Popover,
  PopoverContent,
  PopoverAnchor,
} from "@bigbinary/neeto-atoms/primitives";
import { BookOpen, MessageCircleQuestion, Users, Activity } from "lucide-react";
import { toLower } from "ramda";
import { useTranslation } from "react-i18next";

import { MENU_ITEM_CLASS } from "./constants";
import MenuButton from "./MenuButton";

const HelpMenu = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setOpen(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    timeoutRef.current = setTimeout(() => setOpen(false), 150);
  }, []);

  return (
    <Popover {...{ open }} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <MenuButton
          onClick={() => setOpen(prev => !prev)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </PopoverAnchor>
      <PopoverContent
        align="center"
        className="z-[99999] w-56 gap-0.5 p-1"
        side="right"
        sideOffset={8}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onOpenAutoFocus={e => e.preventDefault()}
      >
        <a
          className={MENU_ITEM_CLASS}
          data-testid="help-link-help-articles-button"
          href={`https://help.${toLower(globalProps?.appName || "")}.com/`}
          rel="noreferrer"
          target="_blank"
        >
          <BookOpen size={18} />
          {t("neetoMolecules.sidebar.helpLinks.helpArticles")}
        </a>
        <button
          className={MENU_ITEM_CLASS}
          data-testid="help-link-live-chat-button"
          type="button"
          onClick={() => {
            window.NeetoChat?.contextualHelp?.maximizeWidget();
            window.NeetoChat?.contextualHelp?.openWidget();
          }}
        >
          <MessageCircleQuestion size={18} />
          {t("neetoMolecules.sidebar.helpLinks.liveChat")}
        </button>
        <a
          className={MENU_ITEM_CLASS}
          data-testid="help-link-community-button"
          href="https://www.launchpass.com/neetohq"
          rel="noreferrer"
          target="_blank"
        >
          <Users size={18} />
          {t("neetoMolecules.sidebar.helpLinks.askTheCommunity")}
        </a>
        <a
          className={MENU_ITEM_CLASS}
          data-testid="help-link-status-button"
          href="https://neetostatus.com/"
          rel="noreferrer"
          target="_blank"
        >
          <Activity size={18} />
          {t("neetoMolecules.sidebar.helpLinks.systemStatus")}
        </a>
      </PopoverContent>
    </Popover>
  );
};

export default HelpMenu;
